import { render, staticRenderFns } from "./SaveCancel.vue?vue&type=template&id=f5d5330a&scoped=true&"
import script from "./SaveCancel.vue?vue&type=script&lang=js&"
export * from "./SaveCancel.vue?vue&type=script&lang=js&"
import style0 from "./SaveCancel.vue?vue&type=style&index=0&id=f5d5330a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d5330a",
  null
  
)

export default component.exports